<template>
    <div class="sidebar" :class="{ open: open }">
        <div v-if="isMobile" class="collapser" @click="open = !open">
            <img class="icon" src="img/icons/ico-chevron-up.svg">
            <h5 v-if="open" class="title">Sair da Simulação</h5>
            <h5 v-else class="title">Iniciar Simulação</h5>
        </div>
        <div class="sidebar-content">
            <img src="img/logo.png" alt="Logo smartbrain" class="logo-sb">
            <div v-if="!isMobile" class="sidebar-header" :class="{ 'justify-content-around': isMobile }">
                <img src="img/logo-comparador.svg" alt="App Logo" class="logo">
            </div>
            <BuscarAtivoForm @acaoRealizada="ativoSelecionado"/>
            <img src="img/by-smartbrain.svg" alt="Logo smartbrain" class="logo-by-sb">
        </div>
    </div>
</template>

<script>
import Vue from "vue"
import BuscarAtivoForm from "@/app/components/Desktop/Forms/BuscarAtivoForm"

export default {
	components: { BuscarAtivoForm, },
	data() {
		return {
            open: false
		}
	},
	methods: {
		ativoSelecionado(props) {
            this.open = false
            window.scrollTo(0, 0)

			Vue.notify({
				title: "Sucesso",
				type: "success",
				group: "principal",
				text: "Ativo adicionado com sucesso.",
				duration: 5000,
			});

			this.$store.commit("addAtivo", props.ativo);
			this.$emit("acaoRealizada");
		},
	},
	computed: {
        isMobile() {
            return this.$mq == 'mobile';
        }
	}
};
</script>

<style lang="scss">
.sidebar-wrapper {
    overflow: hidden;
}

.sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: $sidebar-wd;
    background: $sidebar-bg;
    box-shadow: 4px 2px 42px rgba(0, 0, 0, 0.04);
    padding: 32px 16px;
    z-index: 10;
    overflow-y: auto;
    color: $alt-bg;
    display: flex;
    flex-direction: column;
    align-items: center;

    .collapser {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 80px;
        transition: margin 1s;
        width: 100%;

        .icon {
            margin-bottom: 12px;
            transition: 1s;
        }
    }

    .sidebar-content {
        flex-grow: 0;
        display: flex;
        flex-direction: column;
        max-width: 100%;

        .sidebar-header {
            align-items: center;
            display: flex;
            flex-direction: row;
            margin-bottom: 56px;

            .logo {
                margin: 0 auto;
                max-width: 205px;
            }
        }
    }

    .logo-sb {
        margin: 0 auto 32px;
        max-width: 198px;
        height: 25px;
    }

    .logo-by-sb {
        margin: 64px auto 0;
        width: 91px;
    }
}

.hooper {
    height: auto;
}

.pikaday-header {
    max-width: 130px;
    padding-right: 0;
    z-index: 2;
    background: transparent;
}

.pikaday-header-icon {
    margin-left: -24px;
}

// Mobile
.mobile .sidebar {
    top: auto;
    bottom: 0;
    width: 100%;
    height: 80px;
    padding-top: 0;
    padding-bottom: 0;
    transition: height 1s;
    overflow: hidden;

    .sidebar-content {
        height: 0;
        overflow: hidden;
    }

    .logo-by-sb {
        margin-top: 8px;
    }

    &.open {
        top: 0;
        bottom: 0;
        height: 100%;
        padding-bottom: 16px;
        overflow: auto;
        animation: open-sidebar 1s;

        .collapser {
            .icon {
                transform: rotate(180deg);
            }
        }

        .sidebar-content {
            height: unset;
        }
    }
}

@media (max-width: 985px) {
    body.menu-open {
        overflow: hidden !important;
    }
}

@keyframes open-sidebar {
    from { top: calc(100% - 80px); }
}
</style>
